import { render } from "./ListInfo.vue?vue&type=template&id=74049350"
import script from "./ListInfo.vue?vue&type=script&lang=js"
export * from "./ListInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__